import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/unipi.png'


const _hoisted_1 = { class: "md:flex h-full md:h-screen md:w-screen md:-mx-6 lg:-mx-10 -my-2 md:-my-4" }
const _hoisted_2 = { class: "flex relative md:w-11/12 flex-col items-center h-full md:shadow-elevation-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mt-4 md:w-7/12 w-10/12"
}, null, -1)
const _hoisted_4 = { class: "w-11/12 absolute top-1/2 transform -translate-x-1/2 -translate-y-1/2 left-1/2 flex items-center flex-col" }
const _hoisted_5 = { class: "mx-auto mb-8 text-5xl text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"150px","height":"150px"},
  class: "mx-auto flex bg-opacity-100 rounded-full bg-primary shadow-elevation-2"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    style: {"font-size":"145px"},
    class: "opacity-100 material-icons m-auto text-light"
  }, " person ")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "mx-4 w-full px-4 space-x-3 banner banner-danger mt-6"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"40px","height":"40px","padding-left":"2.5px"},
  class: "flex items-start rounded-full"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "m-auto material-icons",
    style: {"font-size":"35px"}
  }, "remove_circle_outline")
], -1)
const _hoisted_9 = { class: "text-danger-dark" }
const _hoisted_10 = { class: "mt-8 text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2.5",
  style: {"width":"30px"},
  src: _imports_1
}, null, -1)
const _hoisted_12 = { class: "mb-1 mt-auto mr-auto ml-2 md:ml-4 opacity-0" }
const _hoisted_13 = { class: "text-xs text-muted" }
const _hoisted_14 = { class: "text-primary hover:underline cursor-pointer" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full text-sm px-2 md:px-4 py-4 bg-light\"><div class=\"flex items-center\"><p class=\"\"><span class=\"mr-0.5\">©</span><a target=\"_blank\" class=\"font-medium text-primary hover:underline\" href=\"https://evo-learning.com\">Evo Learning</a></p></div></div>", 1)
const _hoisted_16 = { class: "w-full relative hidden md:flex h-full px-2 md:px-6 lg:px-10 py-4 hero-bg" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"72px !important"},
  class: "material-icons"
}, "code", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"72px !important"},
  class: "material-icons"
}, "assignment_turned_in", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"72px !important"},
  class: "material-icons"
}, "book", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"72px !important"},
  class: "material-icons"
}, "bar_chart", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"72px !important"},
  class: "material-icons"
}, "school", -1)
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_GoogleLogin = _resolveComponent("GoogleLogin")!
  const _component_v_tour = _resolveComponent("v-tour")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("headings.login")), 1),
        _hoisted_6,
        (_ctx.loginAttemptWithUnauthorizedEmailAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("login_screen.unauthorized_email_1")) + " ", 1),
                  _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.$t("login_screen.unauthorized_email_2")), 1),
                  _createTextVNode(". ")
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_GoogleLogin, {
            "popup-type": 'TOKEN',
            callback: _ctx.onLogin
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Btn, {
                id: "login-btn",
                variant: 'secondary',
                size: 'lg',
                class: "md:w-max",
                style: {"background":"white !important"},
                disabled: _ctx.localLoading || _ctx.disableLogin,
                loading: _ctx.localLoading
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("login_screen.login")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          }, 8, ["callback"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.$t("login_screen.entering_you_agree_to")) + " ", 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("misc.terms_and_conditions")), 1),
          _createTextVNode(". ")
        ])
      ]),
      _hoisted_15
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", {
        style: {"top":"10%","left":"70%"},
        class: _normalizeClass(["hero-icon", { 'hero-hidden': !_ctx.showIcons }])
      }, _hoisted_18, 2),
      _createElementVNode("div", {
        style: {"bottom":"10%","right":"70%"},
        class: _normalizeClass(["hero-icon", { 'hero-hidden': !_ctx.showIcons }])
      }, _hoisted_20, 2),
      _createElementVNode("div", {
        style: {"bottom":"30%","right":"10%"},
        class: _normalizeClass(["hero-icon", { 'hero-hidden': !_ctx.showIcons }])
      }, _hoisted_22, 2),
      _createElementVNode("div", {
        style: {"top":"32.5%","left":"10%"},
        class: _normalizeClass(["hero-icon", { 'hero-hidden': !_ctx.showIcons }])
      }, _hoisted_24, 2),
      _createElementVNode("div", {
        style: {"position":"relative !important"},
        class: _normalizeClass(["hero-icon m-auto", { 'hero-hidden': !_ctx.showIcons }])
      }, _hoisted_26, 2)
    ]),
    _createVNode(_component_v_tour, {
      name: "demoTour",
      steps: _ctx.demoLoginTourSteps,
      options: _ctx.tourOptions,
      callbacks: { onFinish: _ctx.onTourFinish }
    }, null, 8, ["steps", "options", "callbacks"])
  ]))
}